module.exports = __webpack_public_path__ + "static/media/condoms-green.42836b71.svg";